import { SxProps, Theme } from "@mui/material";
import { Colors } from "../../constants";

export const tabsStyles: SxProps<Theme> = {
	backgroundColor: Colors.transparent,
	minHeight: '0',

	'& .MuiTabs-flexContainer': {
		gap: '16px',
	},

	'& .MuiTabs-indicator': {
		backgroundColor: Colors.white,
	},

	'& .MuiTabs-scroller': {
		borderBottom: `1px solid ${Colors['D7D7D74D']}`,
	},
};

export const tabStyles: SxProps<Theme> = {
	color: Colors.white,
	backgroundColor: Colors.transparent,
	textTransform: 'none',
	padding: '4px 8px',
	minHeight: '0',

	'&.Mui-selected': {
		color: Colors.white,
		backgroundColor: Colors.transparent,
	},

	'&:hover': {
		color: Colors.white,
		backgroundColor: Colors.white_a5,
	},
};
